export default {
  
  en: {
    assign: 'assign',
    teleMarketUser: 'Telemarketer',
    days: 'time limit',
    days_today: 'today',
    days_yesterday: 'yesterday',
    days_last3days: 'last 3 days',
    days_last7days: 'last 7 days',
    days_last30days: 'last 30 days',
    days_other: 'customize',
    createdTime: 'customize',
    transfer: 'Turn order',
    completed: 'completed',
    donotFollowUp: 'Not followed up',
    followUping: 'Have followed up',
    type: 'Telemarketing type',
    registerTime: 'Registration time',
    allTypes: 'all types',
    allUsers: 'all staff',
    type_undefined: ' ',
    type_1: 'Send verification code Not logged in',
    type_2: 'Basic information not submitted',
    type_3: 'Contact not submitted',
    type_4: 'ID card not submitted',
    type_5: 'Bank card not submitted',
    type_6: 'Order not submitted',
    type_7: 'Cleared 1-7 days without conversion',
    type_8: 'Early settlement(new customer)',
    type_9: 'Early settlement(old customer)',
    type_10: 'Registration not applied',
    type_11: 'Settled unconverted',
    type_12: 'The first loan was not refinanced',
    type_13: 'Settled unconverted(new customer)',
    type_14: 'Settled unconverted(old customer)',
    followStatus_0: 'Not followed up',
    followStatus_1: 'Have followed up',
    followStatus_2: 'completed',
    assignTime: 'Assign time',
    followStatus: 'status',
    mobile: 'Mobile',
    email: 'Email',
    assignDefaultShow: 'Default is 0',
    seatMobile: 'Login Account',
    seat: 'Seat',
    seatStatus: 'seat Status',
    seatStatus_0: 'enable',
    seatStatus_1: 'disable',
    operate: 'Operate',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    id: 'ID',
    convertStatus: 'conversion state',
    convertStatus_0: 'not converted',
    convertStatus_1: 'converted',
    dataDate: 'Date',
    app: 'Loan Products',
    appName: 'Application Name',
    t1Convert: 'conversions',
    assignNum: 'Distribution of the day',
    loadNum: 'load number',
    followNum: 'Number of follow ups',
    convertNum: 'conversions',
    recycle: 'Recycle',
    reAssign: 'Re Assign',
    assignStatus: 'Assign Status',
    assignStatus_0: 'Not assigned',
    assignStatus_1: 'Assigned',
    assignStatus_2: 'Recycled',
    recycleNum: 'Recycling quantity',
    all: 'All',
    lastSettleTime: 'Last Settle Time',
    appSsidNotice: 'Please select Package Name',
    convertRate: 'Convert Rate',
    totalAssignNum: 'total loan allocation',
    totalConvertNum: 'total loan conversions',
    totalConvertRate: 'total loan conversion rate',
    averageAssignNum: 'average loan daily allocation',
    averageConvertNum: 'average loan daily conversions',
    loanType: 'Business Type',
    loanType_1: 'First Loan',
    loanType_2: 'Reloan',
    loanType_3: 'First Loan And ReLoan',
    loanType_4: 'Early settlement',
    passNum: 'pass num',
    passRate: 'pass rate',
    summary: 'summary',
    convertNumT0: 'T0 conversions',
    convertNumT1: 'T1 conversions',
    convertNumT2: 'T2 conversions',
    convertNumT3: 'T3 conversions',
    convertNumT4: 'T4 conversions',
    convertNumT5: 'T5 conversions',
    convertNumT6: 'T6 conversions',
    convertNumT7: 'T7 conversions',
    convertRateT0: 'T0 Convert Rate',
    convertRateT1: 'T1 Convert Rate',
    convertRateT2: 'T2 Convert Rate',
    convertRateT3: 'T3 Convert Rate',
    convertRateT4: 'T4 Convert Rate',
    convertRateT5: 'T5 Convert Rate',
    convertRateT6: 'T6 Convert Rate',
    convertRateT7: 'T7 Convert Rate',
    passNumT0: 'T0 pass num',
    passNumT1: 'T1 pass num',
    passNumT2: 'T2 pass num',
    passNumT3: 'T3 pass num',
    passNumT4: 'T4 pass num',
    passNumT5: 'T5 pass num',
    passNumT6: 'T6 pass num',
    passNumT7: 'T7 pass num',
    passRateT0: 'T0 pass Rate',
    passRateT1: 'T1 pass Rate',
    passRateT2: 'T2 pass Rate',
    passRateT3: 'T3 pass Rate',
    passRateT4: 'T4 pass Rate',
    passRateT5: 'T5 pass Rate',
    passRateT6: 'T6 pass Rate',
    passRateT7: 'T7 pass Rate',
    followUp: 'follow up',
    followUpStatus: 'follow up status',
    followUpStatus_0: 'not connected',
    followUpStatus_1: 'Not interested in',
    followUpStatus_2: 'Applied for a loan',
    followUpStatus_3: 'It is possible to apply for a loan',
    followUpStatus_4: 'Need to follow up again',
    followUpStatus_5: 'available by phone',
    followUpStatus_6: 'wa available',
    followUpStatus_7: 'Email available',
    followUpStatus_8: 'Account does not exist',
    followUpStatus_a: 'Answer in person',
    followUpStatus_b: 'Not in person',
    followUpStatus_c: 'No answer',
    followUpStatus_d: 'Empty number',
    followUpStatus_e: 'Turn off the phone',
    followUpStatus_f: 'Disconnected',
    followUpStatus_g: 'Promise to pay on time on Whatsapp',
    followUpStatus_h: 'No reply on Whatsapp',
    followUpStatus_i: 'No whatsapp account',
    followUpStatus_j: 'To be followed up',
    userName: 'name',
    baseInfoSubmitTime: 'Basic information submission time',
    linkManSubmitTime: 'Contact Information Submission Time',
    idInfoSubmitTime: 'ID information submission time',
    bankInfoSubmitTime: 'Bank card submission time',
    orderSubmitTime: 'order submission time',
    userDetail: 'User Info',
    teleMarketDetail: 'Telemarketing details',
    userOperateHistory: 'User Operation History',
    followUpHistory: 'follow up history',
    followUpTime: 'follow up time',
    followUpUser: 'follow up User',
    remark: 'Remark',
    attachments: 'attachment',
    attachment: 'attachment',
    imgCountLimitNotice: 'You can only upload up to 4 pictures',
    uploadImage: 'upload image',
    call: 'dial',
    upload: 'Upload',
    followUpNotice: 'Please select a follow up status',
    nxAccount: 'NIUXIN account',
    nxPassword: 'NIUXIN password',
    imageLoadingNotice: 'Image uploading...',
    type_8_pre: '',
    type_8_suf: ' day early settlement(new customer)',
    earlySettleNotice: 'Early settlement needs to fill in the number of days in advance',
    earlySettleNum: 'Early settlement num',
    earlySettleRate: 'Early clearance rate',
    totalEarlySettleAssignNum: 'Early settlement of total allocations',
    totalEarlySettleNum: 'Early settlement of total conversions',
    totalEarlySettleRate: 'Early closing total conversion rate',
    averageEarlySettleAssignNum: 'Early settlement of average daily allotments',
    averageEarlySettleNum: 'Early Closing Average Daily Conversions',
    notApplyReason: 'Reason for not applying for a loan',
    notApplyReason_a: 'High interest rate',
    notApplyReason_b: 'Low amount',
    notApplyReason_c: 'Short repayment time',
    notApplyReason_d: 'Long approval time',
    notApplyReason_e: 'violent collection',
    notApplyReason_f: 'Many negative reviews',
    notApplyReason_g: 'access to personal information',
    notApplyReason_h: 'No need for a loan',
    notApplyReason_i: 'App bug',
    notApplyReason_j: 'Downloaded the app by mistake',
    notApplyReason_k: 'other reason',
    type_9_pre: '',
    type_9_suf: ' day early settlement(old customer)',
    lastApplyTime: 'latest application time',
    exportTagData: 'Export label',
    downloadTagDataNotice: 'Please select follow up time',
    lastFollowUpTime: 'Last follow up time',
    lastFollowUpStatus: 'Last follow-up status',
    lastNotApplyReason: 'The reason for not applying for a loan in the latest follow-up',
    lastFollowRemark: 'Last follow up note',
    createGroup: 'generate user group',
    groupName: 'user group name',
    noGroupNameNotice: 'Please enter user group name',
    noSelectUserNotice: 'Please select telemarketers',
    noTypeCountNotice: 'Please enter the type quantity',
    type_10_pre: 'Registration did not apply for ',
    type_10_suf: ' hours',
    registerNoApplyNotice: 'Registration without application needs to fill in the correct number of hours',
    scrmExport: 'SCRM export',
    exportType: 'Export type',
    exportType_t1_convert: 'T1 Convert',
    duration: 'Duration(Only for early settlement)',
    duration_7: '7 Days',
    duration_14: '14 Days',
    duration_15: '15 Days',
    duration_21: '21 Days',
    copy: 'Copy',
    repayUrl: 'Repay Url',
    allDuration: 'all duration',
    type_11_pre: 'Settlement',
    type_11_suf: ' days unconverted',
    settleNoConversionNotice: 'You need to fill in the correct number of days to settle unconverted items',
    remarkNotice: 'Please fill in the remarks',
    curStage: 'Uncommitted',
    curStage_basicinfo: "Basic information has not been submitted",
    curStage_linkedman: "Contact not submitted",
    curStage_idno: "Identity information not submitted",
    curStage_bankcard: "Bank card not submitted",
    curStage_apply: "Application information not submitted",
    curStage_over: "Loan application submitted",
    notApplySubReasonNotice: 'Please select the reason for not applying',
    notApplySubReason: 'sub-item of reason for not applying for loan',
    lastNotApplySubReason: 'The latest follow-up reason for not applying for a loan',
    bugNotice: 'For crash and button failure bugs, you need to provide the phone model and page, and for other types of bugs, you need to upload videos or screenshots',
    type_12_pre: 'The first loan was not refinanced within ',
    type_12_suf: ' minutes',
    firstSettleNoConversionNotice: 'You need to fill in the correct number of minutes to settle the first loan but not the second loan',
    callNum: 'Dial number',
    connectNum: 'Connection number',
    connectNum5: 'Connection number by phone',
    connectNum6: 'Connection number by whatapp',
    connectNum7: 'Connection number by email',
    cloudCallSeat: 'Cloud seat account',
    cloudCallSeatPassword: 'Cloud Seat Password',
    unbindClousSeat: 'Unbind cloud seat',
    confirmUnbind: 'Are you sure you want to unbind?',
    assignNum1: 'Assigned quantity',
    realNum: 'Actual quantity',
    batchId: 'Batch number',
    param: 'Parameter',
    registerStartDate: 'Registration start date',
    registerEndDate: 'Registration end date',
    assignStatus1_0: 'Failed',
    assignStatus1_1: 'Successful',
    type_13_pre: '',
    type_13_suf: ' days after settlement without conversion(new customer)',
    type_14_pre: '',
    type_14_suf: ' days after settlement without conversion(old customer)',
    seatType: 'seat type',
    startTime: 'start time',
    endTime: 'end time',
    type_15_pre: 'Loan failed and card not bound for ',
    type_15_suf: ' hours(new customer)',
    type_16_pre: 'Loan failed and card not bound for ',
    type_16_suf: ' hours(old customer)',
    loanFailedNoRebindCardNotice: 'Loan failed and card not bound. Please fill in the correct number of hours',
    userGroupName: 'Group Name',
    userGroupName_zhh: 'Group Name (English)',
    userGroupName_en: 'Group Name (English)',
    userGroupName_es: 'Group Name (Spanish)',
    userGroupName_fr: 'Group Name (French)',
    userGroupStatus: 'Status',
    countPre: 'Allocation Cap',
    createUser: 'Create User',
    updateUser: 'Update User',
    dataId: 'Telemarketing Data ID',
    callCount: 'Number of Calls',
    totalCallDuration: 'Total Call Duration',
    avgCallDuration: 'Average Call Duration',
    avgPageDwellTime: 'Average Page Dwell Time',
    callRate: 'Dialing rate',
    connectRate: 'Connection rate',
    name: 'name',
    smsTemplate: 'SMS template',
    urlType: 'Link type',
    url: 'Link',
    sort: 'Sort',
    otherPanToNewPanNotice: 'Other disks need to correctly fill in parameters when booting into new disks',
    type_27_pre: '',
    type_27_suf: ' days after settlement without conversion call to',
    type_30_pre: 'within ',
    type_30_mid: ' days marketing score is ',
    type_30_suf: ' and no loan application is made after registration',
    registerNoApplyHasMarketScoreNotice: 'Registration without application (marketing points) requires correct filling of parameters',
    type_31_pre: 'within ',
    type_31_mid: ' days marketing score is ',
    type_31_suf: ' and settlement without conversion',
    settleNoConversionHasMarketScoreNotice: 'Settled unconverted(marketing points) requires correct filling of parameters',
    userGroup: 'User group',
    noGroup: 'No group',
    autoGen: 'generate account, seat, password',
    password: 'Login password',
    confirmRecycle: 'Are you sure you want to recycle?',
    applyStatus: 'Loan application status',
    applyStatus_0: 'Not applied for loan',
    applyStatus_1: 'Already applied for loan',
    totalNum: 'total num',
    totalNumNew: 'total num (evening)',
    noAssignNum: 'Unassigned num',
    realAssignNum: 'Actual assigned num',
    noFollowNum: 'Unfollowed num',
    typeConfig: 'Type Configuration',
    typeConfigNum: 'Num',
    other: 'Other',
    clear: 'Clear',
    taskChannel: 'Task Channel',
    taskStatus: 'Task Status',
    strategyId: 'Strategy ID',
    thirdTaskId: 'Third-Party Task ID',
    connectNotCall: 'Number of Connected Calls',
    convertNotCall: 'Convert to Call',
    convertNotCall_0: 'Off',
    convertNotCall_1: 'On',
    accessKeys: 'Third-Party Key',
    taskIds: 'Task ID List',
    taskList: 'Task List',
    custId: 'Customer ID',
    orderId: 'Order ID',
    keyword: 'Remark keyword',
    relationName: 'Relation Name',
    relationKey1: 'Type 1',
    relationKey2: 'Type 2',
    relationRate1: 'Rate 1',
    relationRate2: 'Rate 2',
    relationStatus: 'Relation Status',
    relationType: 'Relation Type',
    type_225: 'Click Repay Before Due Date But not Repay',
    type_226: 'Click Repay Before Due Date After Collection But not Repay'
  },
  es: {
    assign: 'Phân bổ',
    teleMarketUser: 'Nhân viên telesale',
    days: 'Phạm vi thời gian',
    days_today: 'Hôm nay',
    days_yesterday: 'Hôm qua',
    days_last3days: '3 ngày gần đây',
    days_last7days: '7 ngày gần đây',
    days_last30days: '30 ngày gần đây',
    days_other: 'Tùy chỉnh',
    createdTime: 'Thời gian tùy chỉnh',
    transfer: 'Chuyển đơn',
    completed: 'Đã hoàn thành',
    donotFollowUp: 'Chưa theo dõi',
    followUping: 'Đã theo dõi',
    type: 'Loại phân nhóm',
    registerTime: 'Thời gian đăng ký',
    allTypes: 'Tất cả loại',
    allUsers: 'Tất cả nhân viên',
    type_undefined: ' ',
    type_1: 'Gửi mã OTP nhưng chưa đăng nhập',
    type_2: 'Chưa gửi thông tin cơ bản',
    type_3: 'Chưa gửi thông tin liên hệ',
    type_4: 'Chưa gửi thẻ ID',
    type_5: 'Chưa gửi thẻ ngân hàng',
    type_6: 'Đơn chưa gửi',
    type_7: 'Tất toán 1-7 ngày chưa chuyển đổi',
    type_8: 'Khách mới – tất toán sớm 1–2 ngày',
    type_9: 'Khách cũ– tất toán sớm 1–2 ngày',
    type_10: 'Đăng ký 1–3 giờ chưa nộp',
    type_11: 'Tất toán chưa chuyển đổi',
    type_12: 'Khách vay lần đầu – hết hạn 90 phút chưa vay lại',
    type_13: 'Khách mới tất toán 1–2 ngày chưa chuyển đổi',
    type_14: 'Khách cũ tất toán 1–2 ngày chưa chuyển đổi',
    followStatus_0: 'Chưa theo dõi',
    followStatus_1: 'Đã theo dõi',
    followStatus_2: 'Đã hoàn thành',
    assignTime: 'Thời gian phân đơn',
    followStatus: 'Trạng thái',
    mobile: 'Số điện thoại',
    email: 'Email',
    assignDefaultShow: 'Mặc định là 0',
    seatMobile: 'Tài khoản đăng nhập',
    seat: 'Ghế',
    seatStatus: 'Trạng thái ghế',
    seatStatus_0: 'Hiệu lực',
    seatStatus_1: 'Không hiệu lực',
    operate: 'Thao tác',
    createTime: 'Thời gian tạo',
    updateTime: 'Thời gian cập nhật',
    id: 'ID',
    convertStatus: 'Trạng thái chuyển đổi',
    convertStatus_0: 'Chưa chuyển đổi',
    convertStatus_1: 'Đã chuyển đổi',
    dataDate: 'Ngày',
    app: 'Sản phẩm vay',
    appName: 'Tên ứng dụng',
    t1Convert: 'Số đơn chuyển đổi',
    assignNum: 'Số đơn phân trong ngày',
    loadNum: 'Lượng tải',
    followNum: 'Số đơn đã theo dõi',
    convertNum: 'Số chuyển đổi',
    recycle: 'Thu hồi',
    reAssign: 'Phân bổ lại',
    assignStatus: 'Hạn mức phân đơn',
    assignStatus_0: 'Chưa phân bổ',
    assignStatus_1: 'Đã phân bổ',
    assignStatus_2: 'Đã thu hồi',
    recycleNum: 'Số đơn thu hồi',
    all: 'Tất cả',
    lastSettleTime: 'Thời gian tất toán lần cuối',
    appSsidNotice: 'Vui lòng chọn gói',
    convertRate: 'Tỷ lệ chuyển đổi',
    totalAssignNum: 'Tổng số phân bổ vay lần đầu/lần sau',
    totalConvertNum: 'Tổng số chuyển đổi vay lần đầu/lần sau',
    totalConvertRate: 'Tổng tỷ lệ chuyển đổi vay lần đầu/lần sau',
    averageAssignNum: 'Số phân bổ trung bình ngày vay lần đầu/lần sau',
    averageConvertNum: 'Số chuyển đổi trung bình ngày vay lần đầu/lần sau',
    loanType: 'Loại hình kinh doanh',
    loanType_1: 'Vay lần đầu',
    loanType_2: 'Vay lại',
    loanType_3: 'Vay lần đầu/lần sau',
    loanType_4: 'Tất toán trước hạn',
    passNum: 'Số đơn thông qua',
    passRate: 'Tỷ lệ thông qua',
    summary: 'Tổng hợp',
    convertNumT0: 'Số chuyển đổi T0',
    convertNumT1: 'Số chuyển đổi T1',
    convertNumT2: 'Số chuyển đổi T2',
    convertNumT3: 'Số chuyển đổi T3',
    convertNumT4: 'Số chuyển đổi T4',
    convertNumT5: 'Số chuyển đổi T5',
    convertNumT6: 'Số chuyển đổi T6',
    convertNumT7: 'Số chuyển đổi T7',
    convertRateT0: 'Tỷ lệ chuyển đổi T0',
    convertRateT1: 'Tỷ lệ chuyển đổi T1',
    convertRateT2: 'Tỷ lệ chuyển đổi T2',
    convertRateT3: 'Tỷ lệ chuyển đổi T3',
    convertRateT4: 'Tỷ lệ chuyển đổi T4',
    convertRateT5: 'Tỷ lệ chuyển đổi T5',
    convertRateT6: 'Tỷ lệ chuyển đổi T6',
    convertRateT7: 'Tỷ lệ chuyển đổi T7',
    passNumT0: 'Số duyệt qua T0',
    passNumT1: 'Số duyệt qua T1',
    passNumT2: 'Số duyệt qua T2',
    passNumT3: 'Số duyệt qua T3',
    passNumT4: 'Số duyệt qua T4',
    passNumT5: 'Số duyệt qua T5',
    passNumT6: 'Số duyệt qua T6',
    passNumT7: 'Số duyệt qua T7',
    passRateT0: 'Tỷ lệ duyệt T0',
    passRateT1: 'Tỷ lệ duyệt T1',
    passRateT2: 'Tỷ lệ duyệt T2',
    passRateT3: 'Tỷ lệ duyệt T3',
    passRateT4: 'Tỷ lệ duyệt T4',
    passRateT5: 'Tỷ lệ duyệt T5',
    passRateT6: 'Tỷ lệ duyệt T6',
    passRateT7: 'Tỷ lệ duyệt T7',
    followUp: 'Theo dõi',
    followUpStatus: 'Trạng thái theo dõi',
    followUpStatus_0: 'Không liên lạc được',
    followUpStatus_1: 'Không quan tâm',
    followUpStatus_2: 'Đã đăng ký vay',
    followUpStatus_3: 'Có khả năng đăng ký vay',
    followUpStatus_4: 'Cần theo dõi lại',
    followUpStatus_5: 'Liên lạc được qua điện thoại',
    followUpStatus_6: 'Liên lạc được qua WA',
    followUpStatus_7: 'Liên lạc được qua email',
    followUpStatus_8: 'Tài khoản không tồn tại',
    followUpStatus_a: 'Chính chủ nghe máy',
    followUpStatus_b: 'Không phải chính chủ nghe',
    followUpStatus_c: 'Không ai nghe máy',
    followUpStatus_d: 'Số rỗng',
    followUpStatus_e: 'Máy tắt',
    followUpStatus_f: 'Số ngừng hoạt động',
    followUpStatus_g: 'Whatsapp cam kết trả nợ đúng hạn',
    followUpStatus_h: 'Whatsapp không trả lời',
    followUpStatus_i: 'Không có tài khoản whatsapp',
    followUpStatus_j: 'Chờ theo dõi',
    userName: 'Tên',
    baseInfoSubmitTime: 'Thời gian gửi thông tin cơ bản',
    linkManSubmitTime: 'Thời gian gửi thông tin người liên hệ',
    idInfoSubmitTime: 'Thời gian gửi thông tin ID',
    bankInfoSubmitTime: 'Thời gian gửi thẻ ngân hàng',
    orderSubmitTime: 'Thời gian gửi đơn hàng',
    userDetail: 'Thông tin người dùng',
    teleMarketDetail: 'Chi tiết telesales',
    userOperateHistory: 'Lịch sử thao tác người dùng',
    followUpHistory: 'Lịch sử theo dõi',
    followUpTime: 'Thời gian theo dõi',
    followUpUser: 'Người theo dõi',
    remark: 'Ghi chú',
    attachments: 'Tệp đính kèm',
    attachment: 'Tệp đính kèm',
    imgCountLimitNotice: 'Chỉ có thể tải lên tối đa 4 ảnh',
    uploadImage: 'Tải ảnh lên',
    call: 'Quay số',
    upload: 'Tải lên',
    followUpNotice: 'Vui lòng chọn trạng thái theo dõi',
    nxAccount: 'Tài khoản Niuxin',
    nxPassword: 'Mật khẩu Niuxin',
    imageLoadingNotice: 'Đang tải ảnh lên...',
    type_8_pre: 'Khách mới – tất toán sớm',
    type_8_suf: 'ngày',
    earlySettleNotice: 'Tất toán trước hạn cần nhập đúng số ngày trước hạn',
    earlySettleNum: 'Số tất toán trước hạn',
    earlySettleRate: 'Tỷ lệ tất toán trước hạn',
    totalEarlySettleAssignNum: 'Tổng số phân bổ tất toán trước hạn',
    totalEarlySettleNum: 'Tổng số chuyển đổi tất toán trước hạn',
    totalEarlySettleRate: 'Tổng tỷ lệ chuyển đổi tất toán trước hạn',
    averageEarlySettleAssignNum: 'Số phân bổ trung bình ngày tất toán trước hạn',
    averageEarlySettleNum: 'Số chuyển đổi trung bình ngày tất toán trước hạn',
    notApplyReason: 'Lý do không đăng ký vay',
    notApplyReason_a: 'Lãi suất cao',
    notApplyReason_b: 'Số tiền thấp',
    notApplyReason_c: 'Thời hạn ngắn',
    notApplyReason_d: 'Thời gian xét duyệt lâu',
    notApplyReason_e: 'Thu hồi nợ',
    notApplyReason_f: 'Nhiều đánh giá tiêu cực',
    notApplyReason_g: 'Lấy thông tin cá nhân',
    notApplyReason_h: 'Không cần vay',
    notApplyReason_i: 'Lỗi APP',
    notApplyReason_j: 'Tải nhầm APP',
    notApplyReason_k: 'Khác',
    type_9_pre: 'Khách cũ– tất toán sớm',
    type_9_suf: 'ngày',
    lastApplyTime: 'Thời gian đăng ký gần nhất',
    exportTagData: 'Xuất thẻ dữ liệu',
    downloadTagDataNotice: 'Vui lòng chọn thời gian theo dõi',
    lastFollowUpTime: 'Thời gian theo dõi gần nhất',
    lastFollowUpStatus: 'Trạng thái theo dõi gần nhất',
    lastNotApplyReason: 'Lý do không đăng ký vay gần nhất',
    lastFollowRemark: 'Ghi chú theo dõi gần nhất',
    createGroup: 'tạo nhóm người dùng',
    groupName: 'Tên nhóm người dùng',
    noGroupNameNotice: 'Vui lòng nhập tên nhóm người dùng',
    noSelectUserNotice: 'Vui lòng chọn nhân viên telesales',
    noTypeCountNotice: 'Vui lòng nhập số lượng loại',
    type_10_pre: 'Đăng ký',
    type_10_suf: 'giờ chưa nộp',
    registerNoApplyNotice: 'Đăng ký chưa đăng ký vay cần nhập đúng số giờ',
    scrmExport: 'Xuất SCRM',
    exportType: 'Loại xuất',
    exportType_t1_convert: 'Chuyển đổi T1',
    duration: 'Kỳ hạn (chỉ dùng cho tất toán sớm)',
    duration_7: '7 ngày',
    duration_14: '14 ngày',
    duration_15: '15 ngày',
    duration_21: '21 ngày',
    copy: 'Sao chép',
    repayUrl: 'Link thanh toán',
    allDuration: 'Tất cả thời hạn',
    type_11_pre: 'Tất toán',
    type_11_suf: 'ngày chưa chuyển đổi',
    settleNoConversionNotice: 'Tất toán chưa chuyển đổi cần nhập đúng số ngày',
    remarkNotice: 'Vui lòng nhập thông tin ghi chú',
    curStage: 'Chưa gửi',
    curStage_basicinfo: 'Chưa gửi thông tin cơ bản',
    curStage_linkedman: 'Chưa gửi thông tin người liên hệ',
    curStage_idno: 'Chưa gửi thông tin căn cước',
    curStage_bankcard: 'Chưa gửi thông tin thẻ ngân hàng',
    curStage_apply: 'Chưa gửi thông tin đăng ký',
    curStage_over: 'Đã gửi đăng ký vay',
    notApplySubReasonNotice: 'Vui lòng chọn lý do phụ không đăng ký vay',
    notApplySubReason: 'Lý do phụ không đăng ký vay',
    lastNotApplySubReason: 'Lý do phụ không đăng ký vay gần nhất',
    bugNotice: 'Lỗi crash và nút không hoạt động cần cung cấp model điện thoại và màn hình, các loại khác cần tải lên video hoặc ảnh chụp màn hình',
    type_12_pre: 'Khách vay lần đầu – hết hạn',
    type_12_suf: 'phút chưa vay lại',
    firstSettleNoConversionNotice: 'Tất toán lần đầu chưa vay lại cần nhập đúng số phút',
    callNum: 'Số lần quay số',
    connectNum: 'Số kết nối',
    connectNum5: 'Số kết nối điện thoại',
    connectNum6: 'Số kết nối WA',
    connectNum7: 'Số kết nối email',
    cloudCallSeat: 'Tài khoản Cloud Seat',
    cloudCallSeatPassword: 'Mật khẩu Cloud Seat',
    unbindClousSeat: 'Hủy liên kết Cloud Seat',
    confirmUnbind: 'Xác nhận hủy liên kết?',
    assignNum1: 'Số lượng phân bổ',
    realNum: 'Số lượng thực',
    batchId: 'Mã đợt phân đơn',
    param: 'Tham số',
    registerStartDate: 'Ngày bắt đầu đăng ký',
    registerEndDate: 'Ngày kết thúc đăng ký',
    assignStatus1_0: 'Thất bại',
    assignStatus1_1: 'Thành công',
    type_13_pre: 'Khách mới tất toán',
    type_13_suf: 'ngày chưa chuyển đổi',
    type_14_pre: 'Khách cũ tất toán',
    type_14_suf: 'ngày chưa chuyển đổi',
    seatType: 'Loại nhân viên tư vấn',
    startTime: 'Thời gian bắt đầu',
    endTime: 'Thời gian kết thúc',
    type_15_pre: 'Khách mới – giải ngân thất bại',
    type_15_suf: 'h chưa liên kết thẻ',
    type_16_pre: 'Khách cũ – giải ngân thất bại',
    type_16_suf: 'h chưa liên kết thẻ',
    loanFailedNoRebindCardNotice: 'Giải ngân thất bại chưa liên kết thẻ cần nhập đúng số giờ',
    userGroupName: 'Tên nhóm',
    userGroupName_zhh: 'Tên nhóm (Tiếng Trung)',
    userGroupName_en: 'Tên nhóm (Tiếng Anh)',
    userGroupName_es: 'Tên nhóm (Tiếng Tây Ban Nha)',
    userGroupName_fr: 'Tên nhóm (Tiếng Pháp)',
    userGroupStatus: 'Trạng thái',
    countPre: 'Giới hạn phân bổ',
    createUser: 'Người tạo',
    updateUser: 'Người cập nhật',
    dataId: 'ID dữ liệu telesales',
    callCount: 'Số lần gọi',
    totalCallDuration: 'Tổng thời lượng cuộc gọi',
    avgCallDuration: 'Thời lượng cuộc gọi trung bình',
    avgPageDwellTime: 'Thời gian ở lại trang trung bình',
    callRate: 'Tỷ lệ quay số',
    connectRate: 'Tỷ lệ kết nối',
    name: 'Tên',
    smsTemplate: 'Mẫu tin nhắn',
    urlType: 'Loại liên kết',
    url: 'Liên kết',
    sort: 'Sắp xếp',
    otherPanToNewPanNotice: 'Chuyển hướng từ nhóm khác sang nhóm mới cần nhập đúng tham số',
    type_27_pre: 'Tất toán',
    type_27_suf: 'ngày chưa chuyển đổi — gọi tự động',
    type_30_pre: 'Trong',
    type_30_mid: 'ngày marketing phân loại ',
    type_30_suf: 'nhưng chưa nộp đơn',

    registerNoApplyHasMarketScoreNotice: 'Đăng ký chưa đăng ký vay (điểm tiếp thị) cần nhập đúng tham số',
    type_31_pre: 'Trong',
    type_31_mid: 'ngày marketing phân loại',
    type_31_suf: 'nhưng tất toán chưa chuyển đổi',
    settleNoConversionHasMarketScoreNotice: 'Tất toán chưa chuyển đổi (điểm tiếp thị) cần nhập đúng tham số',
    userGroup: 'Nhóm người dùng',
    noGroup: 'Chưa phân nhóm',
    autoGen: 'Tự động tạo tài khoản, nhân viên tư vấn, mật khẩu',
    password: 'Mật khẩu đăng nhập',
    confirmRecycle: 'Xác nhận thu hồi?',
    applyStatus: 'Trạng thái đăng ký vay',
    applyStatus_0: 'Chưa đăng ký vay',
    applyStatus_1: 'Đã đăng ký vay',
    totalNum: 'Tổng số',
    totalNumNew: 'Tổng số (tối)',
    noAssignNum: 'Số chưa phân bổ',
    realAssignNum: 'Số phân bổ thực tế',
    noFollowNum: 'Số chưa theo dõi',
    typeConfig: 'Cấu hình loại',
    typeConfigNum: 'Số lượng',
    other: 'Khác',
    clear: 'Xóa',
    taskName: 'Tên nhiệm vụ',
    taskChannel: 'Kênh nhiệm vụ',
    taskStatus: 'Trạng thái nhiệm vụ',
    strategyId: 'ID chiến lược',
    thirdTaskId: 'ID nhiệm vụ bên thứ ba',
    connectNotCall: 'Số kết nối ngừng gọi',
    convertNotCall: 'Ngừng gọi chuyển đổi',
    convertNotCall_0: 'Tắt',
    convertNotCall_1: 'Bật',
    accessKeys: 'Khóa bên thứ ba',
    taskIds: 'Danh sách ID nhiệm vụ',
    taskList: 'Danh sách nhiệm vụ',
    custId: 'ID khách hàng',
    orderId: 'ID đơn hàng',
    keyword: 'Từ khóa ghi chú',
    relationName: 'Tên quan hệ',
    relationKey1: 'Loại 1',
    relationKey2: 'Loại 2',
    relationRate1: 'Tỷ lệ 1',
    relationRate2: 'Tỷ lệ 2',
    relationStatus: 'Trạng thái quan hệ',
    relationType: 'Loại quan hệ',
    type_225: 'Chưa đến hạn Nhấp chuột để thanh toán Không cập nhật',
    type_226: 'T0 vào thúc sau chưa đến hạn nhấp vào thanh toán không được cập nhật',
  },
}